import { PublisherDetailsDashboardContent } from './PublisherDetailsDashboardContent';
import { PublisherLoginDashboardContent } from './PublisherLoginDashboardContent';

export function PublisherDashboardContent({
  publisherId,
  detailsMode = false,
}: {
  publisherId: string;
  detailsMode?: boolean;
}) {
  if (detailsMode) {
    return <PublisherDetailsDashboardContent publisherId={publisherId} />;
  }
  return <PublisherLoginDashboardContent publisherId={publisherId} />;
}
